import { validations } from "../../../../../config/validations/validations";

export const rules: any = {
  short_form: () => [
    validations.required.text(),
    validations.min.text(2),
    validations.max.text(50),
  ],
  acronym: () => [
    validations.required.text(),
    validations.min.text(3),
    validations.max.text(255),
  ],
};
